import IPaperDetailsWithCoordinates from "../../interfaces/paperDetails";
import IPaperMeta from "../../interfaces/paperMeta";

export default function YearDisplay({year}:{year:number}){
    return <div style={{fontSize:'14px'}}>{year}</div>
}